var _excluded = ["error", "warning", "description", "tooltipText", "className", "data-qa"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import IconWithActive from "@components/icon-with-active";
import Icon from "@components/icon";
import Tooltip from "@components/tooltip";
import { joinCn } from "@ati/uti";
import styles from "./InputSubtext.module.scss";
var InputSubtext = _ref => {
  var {
      error = "",
      warning = "",
      description = "",
      tooltipText = "",
      className,
      "data-qa": dataQa = "subtext"
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  if (!error && !warning && !description) return null;
  var message = "";
  var type = null;
  if (description && typeof description === "string") {
    type = "default";
    message = description;
  }
  if (warning && typeof warning === "string") {
    type = "warning";
    message = warning;
  }
  if (error && typeof error === "string") {
    type = "error";
    message = error;
  }
  if (!type) return null;
  return /*#__PURE__*/React.createElement("span", _extends({
    className: joinCn("glz-subtext", "glz-is-".concat(type), styles.subtext, styles["glz-is-".concat(type)], className),
    "data-qa": dataQa
  }, rest), message, tooltipText && /*#__PURE__*/React.createElement(Tooltip, {
    content: tooltipText,
    placement: "top",
    maxWidth: 300,
    zIndex: {
      tip: 10400
    }
  }, /*#__PURE__*/React.createElement(IconWithActive, {
    defaultIcon: /*#__PURE__*/React.createElement(Icon, {
      name: "ic_question-out",
      width: 12
    }),
    activeIcon: /*#__PURE__*/React.createElement(Icon, {
      name: "ic_question-solid",
      width: 12
    })
  })));
};
export default InputSubtext;